import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.dailyWorkApplyController;
const getDailyWorkApply = self.customSetting.getDailyWorkApply;
const postDailyWorkApply = self.customSetting.postDailyWorkApply;

export default {
  getVdrList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getDailyWorkApply}/GetVdrList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getInit: (context, { prjNo, apply_Pk }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getDailyWorkApply}/InsInit?prjNo=${prjNo}&apply_Pk=${apply_Pk}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  insData: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postDailyWorkApply}/insData`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  chkLicense: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postDailyWorkApply}/ChkLicense`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getGroupList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getDailyWorkApply}/GetGroupList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  insGroup: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postDailyWorkApply}/InsGroup`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  delGroupList: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postDailyWorkApply}/DelGroupList`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getEveryDayList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getDailyWorkApply}/getEveryDayList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSignedList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getDailyWorkApply}/getSignedList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getEveryDayDetail: (context, no) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getDailyWorkApply}/GetEveryDayDetail?no=${no}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSignOffDetail: (context, no) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getDailyWorkApply}/GetSignOffDetail?no=${no}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  dailyWorkApplyDownloadPdf: (context, file_id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${getDailyWorkApply}/DownloadPdf?file_id=${file_id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => resolve(res))
        .catch((err) => {
          Vue.prototype.$message({
            type: "error",
            duration: 5000,
            showClose: true,
            message: `失敗: 檔案下載失敗`,
          });
          reject(err);
        });
    });
  },
};
